module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("g49Uw"))).then(() => parcelRequire('cvs7o'));